import styled from "styled-components";
export const NavContainer = styled.section `
	width: 48px;
	position: fixed;
	left: calc(50% - 652px);
	top: 200px;
	z-index: 99;
	background: #fff;

	@media screen and (max-width: 1440px) {
		left: 0;
	}

	& > a {
		display: block;
		height: 48px;
		position: relative;
		cursor: pointer;

		& > img {
			width: 48px;
			height: 48px;
			position: absolute;
			left: 0;
			top: 0;
		}

		& > span {
			position: absolute;
			visibility: hidden;
			overflow: hidden;
			width: 0;
			height: 48px;
			top: 0;
			left: 0;
			padding-left: 48px;
			text-align: center;
			line-height: 48px;
			font-size: 16px;
			transition: all 0.4s ease-in-out;
		}

		&:hover {
			& > img {
				filter: brightness(1.5);
			}
			& > span {
				width: 198px;
				visibility: visible;
			}
		}
	}
`;
export const TitleBox = styled.span `
	color: ${(props) => props.color};
	background-color: ${(props) => props.bgColor};
`;
